/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { TTableColumnCell } from '../../../types';
import TableCell from '../TableCell';
import TableCellNoValue from '../TableCellNoValue';
import LabelCell from './LabelCell';
import { TTableCellLabel } from './types';

function TableCellLabel<D extends object>(cell: TTableCellLabel<D>): Pick<TTableColumnCell<D>, 'Cell'> {

    return {
        Cell: props => TableCell(props)({
            render: ({ row }) => {
                const labels = cell(row);
                return labels.length !== 0
                    ? <LabelCell labels={labels}/>
                    : <TableCellNoValue/>;
            },
        }),
    };
}

export default TableCellLabel;
